<script lang="ts">
  export let loginFunc: (client?: "google" | "facebook") => void;
</script>

<div class="bg">
  <div class="logo">
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 615.63 144.07"
    >
      <g class="cls-1" fill="#fff">
        <g data-name="Layer 1">
          <path
            d="M315,28.89V5a5,5,0,0,0-5-5H208.68a5,5,0,0,0-5,5V139.07a5,5,0,0,0,5,5H310a5,5,0,0,0,5-5V115.18a5,5,0,0,0-5-5H242.57a5,5,0,0,1-5-5V94a5,5,0,0,1,5-5H288.9a5,5,0,0,0,5-5V60.09a5,5,0,0,0-5-5H242.57a5,5,0,0,1-5-5V38.89a5,5,0,0,1,5-5H310A5,5,0,0,0,315,28.89Z"
          />
          <path
            d="M573.05,72,614.82,7.73A5,5,0,0,0,610.62,0H582.13a5,5,0,0,0-4.2,2.28L552.84,40.92,527.75,2.28A5,5,0,0,0,523.56,0H495.07a5,5,0,0,0-4.2,7.73L532.63,72l-41.76,64.31a5,5,0,0,0,4.2,7.72h28.49a5,5,0,0,0,4.19-2.28l25.09-38.63,25.09,38.63a5,5,0,0,0,4.2,2.28h28.49a5,5,0,0,0,4.2-7.72Z"
          />
          <rect class="cls-2" x="447.75" width="33.9" height="144.07" rx="5" />
          <path
            d="M434.34,0H328.45a5,5,0,0,0-5,5V28.9a5,5,0,0,0,5,5h36V139.07a5,5,0,0,0,5,5h23.9a5,5,0,0,0,5-5V33.9h36a5,5,0,0,0,5-5V5A5,5,0,0,0,434.34,0Z"
          />
          <path
            d="M214.47,0h-26.4a5,5,0,0,0-4.54,2.89L152.12,70.27a5,5,0,0,0-.18,3.79,162.72,162.72,0,0,1,6.32,22.13l-7.41,2.57s-1.91-5.7-5.85-4.83a4.12,4.12,0,0,0-.47.13c-2.65.92-3.15,3.74-3.15,5.75a12,12,0,0,0,.19,2.17l-7.09,2.47h0a144.52,144.52,0,0,0-9.64-34.54h0l-9-19.19L97.19,90.82l23.49,50.36a5,5,0,0,0,4.53,2.89h27.4a5,5,0,0,0,4.54-2.91L219,7.09A5,5,0,0,0,214.47,0Z"
          />
          <path
            d="M136.22,7.11l-20.33,43.6L97.19,90.82,73.71,141.18a5,5,0,0,1-4.53,2.89H41.75a5,5,0,0,1-4.53-2.89L.48,62.34A5,5,0,0,1,5,55.23H31.38a5,5,0,0,1,4.54,2.89l11.9,25.55h0a144.06,144.06,0,0,1,9.65,34.52v0l7.1-2.46a12,12,0,0,1-.19-2.17c0-.13,0-.26,0-.39s0-.26,0-.4l0-.41c0-.21.06-.42.1-.63a4.75,4.75,0,0,1,.14-.63,5.69,5.69,0,0,1,.63-1.51,2.11,2.11,0,0,1,.18-.27,5.17,5.17,0,0,1,.42-.51,4.1,4.1,0,0,1,1.61-1,3.06,3.06,0,0,1,.48-.12c3.94-.88,5.85,4.82,5.85,4.82L81.25,110q-.18-.95-.39-2h0l-.06-.25a184,184,0,0,0-6.73-22.32l-.13-.36c-1.46-4-3-7.82-4.41-11.19a5,5,0,0,1,.06-4.07l31.2-66.92A5,5,0,0,1,105.33,0h26.36A5,5,0,0,1,136.22,7.11Z"
          />
          <path
            d="M85.43,106.4,80.86,108l-.06-.25a184,184,0,0,0-6.73-22.32A98.25,98.25,0,0,0,85.43,106.4Z"
          />
          <path
            d="M68.88,112l-4.51,1.57c0-.13,0-.26,0-.39s0-.26,0-.4l0-.41c0-.21.06-.42.1-.63a4.75,4.75,0,0,1,.14-.63,5.69,5.69,0,0,1,.63-1.51,2.11,2.11,0,0,1,.18-.27,5.17,5.17,0,0,1,.42-.51,4.2,4.2,0,0,1,1.61-1l.2-.06h.05l.18,0A7.76,7.76,0,0,0,68.88,112Z"
          />
          <path
            d="M145.89,98.25l-4.51,1.57c0-2,.5-4.83,3.14-5.75l.2-.06h.05l.18,0A7.8,7.8,0,0,0,145.89,98.25Z"
          />
          <path
            d="M151.94,74.06c.23.65.45,1.3.67,2q.44,1.24.84,2.49a1.72,1.72,0,0,1,.07.21c.33,1,.66,2,1,3s.64,2.07.94,3.09c.15.51.3,1,.44,1.52l.42,1.5c.41,1.49.78,2.94,1.11,4.33s.62,2.73.86,4h0v0l2.52-.77-9-22.07Z"
          />
        </g>
      </g>
    </svg>
  </div>
  <div class="login" on:click={() => loginFunc()}>
    <span class="label">Login with Google</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="20px"
      height="20px"
      viewBox="0 0 64 65"
    >
      <g id="surface1">
        <path
          style="stroke:none;fill-rule:nonzero;fill:rgb(25.882353%,52.156863%,95.686275%);fill-opacity:1;"
          d="M 63.964844 33.109375 C 63.964844 30.445312 63.75 28.5 63.277344 26.488281 L 32.636719 26.488281 L 32.636719 38.507812 L 50.621094 38.507812 C 50.261719 41.492188 48.300781 45.992188 43.949219 49.015625 L 43.890625 49.417969 L 53.578125 56.863281 L 54.25 56.929688 C 60.414062 51.28125 63.964844 42.96875 63.964844 33.109375 "
        />
        <path
          style="stroke:none;fill-rule:nonzero;fill:rgb(20.392157%,65.882353%,32.54902%);fill-opacity:1;"
          d="M 32.636719 64.777344 C 41.449219 64.777344 48.84375 61.898438 54.25 56.929688 L 43.949219 49.015625 C 41.195312 50.921875 37.496094 52.253906 32.636719 52.253906 C 24.007812 52.253906 16.683594 46.601562 14.070312 38.792969 L 13.6875 38.828125 L 3.617188 46.5625 L 3.484375 46.925781 C 8.851562 57.507812 19.875 64.777344 32.636719 64.777344 "
        />
        <path
          style="stroke:none;fill-rule:nonzero;fill:rgb(98.431373%,73.72549%,1.960784%);fill-opacity:1;"
          d="M 14.070312 38.792969 C 13.382812 36.777344 12.984375 34.621094 12.984375 32.386719 C 12.984375 30.15625 13.382812 27.996094 14.035156 25.984375 L 14.019531 25.554688 L 3.816406 17.691406 L 3.484375 17.847656 C 1.273438 22.238281 0.00390625 27.171875 0.00390625 32.386719 C 0.00390625 37.605469 1.273438 42.535156 3.484375 46.925781 L 14.070312 38.792969 "
        />
        <path
          style="stroke:none;fill-rule:nonzero;fill:rgb(92.156863%,26.27451%,20.784314%);fill-opacity:1;"
          d="M 32.636719 12.523438 C 38.765625 12.523438 42.898438 15.152344 45.257812 17.347656 L 54.464844 8.421875 C 48.808594 3.203125 41.449219 0 32.636719 0 C 19.875 0 8.851562 7.269531 3.484375 17.847656 L 14.035156 25.984375 C 16.683594 18.171875 24.007812 12.523438 32.636719 12.523438 "
        />
      </g>
    </svg>
  </div>
  <div class="login" on:click={() => loginFunc('facebook')}>
    <span class="label">Login with Facebook</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 256 256" version="1.1" preserveAspectRatio="xMidYMid">
      <title>Facebook</title>
      <g>
        <path d="M256,128 C256,57.3075 198.6925,0 128,0 C57.3075,0 0,57.3075 0,128 C0,191.8885 46.80775,244.8425 108,254.445 L108,165 L75.5,165 L75.5,128 L108,128 L108,99.8 C108,67.72 127.1095,50 156.3475,50 C170.35175,50 185,52.5 185,52.5 L185,84 L168.8595,84 C152.95875,84 148,93.86675 148,103.98925 L148,128 L183.5,128 L177.825,165 L148,165 L148,254.445 C209.19225,244.8425 256,191.8885 256,128" fill="#1877F2"/>
        <path d="M177.825,165 L183.5,128 L148,128 L148,103.98925 C148,93.86675 152.95875,84 168.8595,84 L185,84 L185,52.5 C185,52.5 170.35175,50 156.3475,50 C127.1095,50 108,67.72 108,99.8 L108,128 L75.5,128 L75.5,165 L108,165 L108,254.445 C114.51675,255.4675 121.196,256 128,256 C134.804,256 141.48325,255.4675 148,254.445 L148,165 L177.825,165" fill="#FFFFFF"/>
      </g>
    </svg>
  </div>
</div>

<style lang="scss">
  .bg {
    display: flex;
    justify-content: center;
    color: #fff;
    flex-direction: column;
    align-items: center;
    height: 100%;
    background-color: #fc4451;
  }

  .logo {
    margin: 35px;
    width: 45%;
    max-width: 250px;
  }

  .login {
    display: inline-flex;
    color: #fc4451;
    padding: 10px 25px;
    align-items: center;
    border-radius: 20px;
    background: #fff;

    &:not(:last-of-type) {
      margin-bottom: 15px;
    }

    .label {
      margin-right: 8px;
    }
  }

  @keyframes scale-fade {
    0% {
      opacity: 1;
    }
    10% {
      transform: scale(1.1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      opacity: 0;
      transform: scale(3);
    }
  }
</style>

<!--<script lang="ts">-->
<!--  export let loginFunc: (client?: "google" | "facebook") => void;-->
<!--</script>-->

<!--<div class="login">-->
<!--  <div class="login-wrapper">-->
<!--    <h1>Topupbar</h1>-->
<!--    <button class="login-wrapper__client" on:click={() => loginFunc()}>-->
<!--      <svg-->
<!--        width="35px"-->
<!--        height="36px"-->
<!--        viewBox="0 0 256 262"-->
<!--        version="1.1"-->
<!--        xmlns="http://www.w3.org/2000/svg"-->
<!--        preserveAspectRatio="xMidYMid"-->
<!--      >-->
<!--        <g>-->
<!--          <path-->
<!--            d="M255.878,133.451 C255.878,122.717 255.007,114.884 253.122,106.761 L130.55,106.761 L130.55,155.209 L202.497,155.209 C201.047,167.249 193.214,185.381 175.807,197.565 L175.563,199.187 L214.318,229.21 L217.003,229.478 C241.662,206.704 255.878,173.196 255.878,133.451"-->
<!--            fill="#4285F4"-->
<!--          />-->
<!--          <path-->
<!--            d="M130.55,261.1 C165.798,261.1 195.389,249.495 217.003,229.478 L175.807,197.565 C164.783,205.253 149.987,210.62 130.55,210.62 C96.027,210.62 66.726,187.847 56.281,156.37 L54.75,156.5 L14.452,187.687 L13.925,189.152 C35.393,231.798 79.49,261.1 130.55,261.1"-->
<!--            fill="#34A853"-->
<!--          />-->
<!--          <path-->
<!--            d="M56.281,156.37 C53.525,148.247 51.93,139.543 51.93,130.55 C51.93,121.556 53.525,112.853 56.136,104.73 L56.063,103 L15.26,71.312 L13.925,71.947 C5.077,89.644 0,109.517 0,130.55 C0,151.583 5.077,171.455 13.925,189.152 L56.281,156.37"-->
<!--            fill="#FBBC05"-->
<!--          />-->
<!--          <path-->
<!--            d="M130.55,50.479 C155.064,50.479 171.6,61.068 181.029,69.917 L217.873,33.943 C195.245,12.91 165.798,0 130.55,0 C79.49,0 35.393,29.301 13.925,71.947 L56.136,104.73 C66.726,73.253 96.027,50.479 130.55,50.479"-->
<!--            fill="#EB4335"-->
<!--          />-->
<!--        </g>-->
<!--      </svg>-->
<!--      <span>Login with Google</span>-->
<!--    </button>-->
<!--    <button class="login-wrapper__client" on:click={() => loginFunc('facebook')}>-->
<!--      <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 256 256" version="1.1" preserveAspectRatio="xMidYMid">-->
<!--        <title>Facebook</title>-->
<!--        <g>-->
<!--          <path d="M256,128 C256,57.3075 198.6925,0 128,0 C57.3075,0 0,57.3075 0,128 C0,191.8885 46.80775,244.8425 108,254.445 L108,165 L75.5,165 L75.5,128 L108,128 L108,99.8 C108,67.72 127.1095,50 156.3475,50 C170.35175,50 185,52.5 185,52.5 L185,84 L168.8595,84 C152.95875,84 148,93.86675 148,103.98925 L148,128 L183.5,128 L177.825,165 L148,165 L148,254.445 C209.19225,244.8425 256,191.8885 256,128" fill="#1877F2"/>-->
<!--          <path d="M177.825,165 L183.5,128 L148,128 L148,103.98925 C148,93.86675 152.95875,84 168.8595,84 L185,84 L185,52.5 C185,52.5 170.35175,50 156.3475,50 C127.1095,50 108,67.72 108,99.8 L108,128 L75.5,128 L75.5,165 L108,165 L108,254.445 C114.51675,255.4675 121.196,256 128,256 C134.804,256 141.48325,255.4675 148,254.445 L148,165 L177.825,165" fill="#FFFFFF"/>-->
<!--        </g>-->
<!--      </svg>-->
<!--      <span>Login with Facebook</span>-->
<!--    </button>-->
<!--  </div>-->
<!--</div>-->

<!--<style lang="scss">-->
<!--  .login {-->
<!--    position: relative;-->
<!--    height: 100%;-->
<!--    width: 100%;-->
<!--    display: flex;-->
<!--    justify-content: center;-->
<!--    align-items: center;-->

<!--    &-wrapper {-->
<!--      display: flex;-->
<!--      flex-direction: column;-->
<!--      align-items: center;-->

<!--      h1 {-->
<!--        text-align: center;-->
<!--        font-size: 48px;-->
<!--        margin-bottom: 35px;-->
<!--      }-->

<!--      &__client {-->
<!--        display: flex;-->
<!--        align-items: center;-->
<!--        background-color: white;-->
<!--        border: 1px solid #000;-->
<!--        border-radius: 999px;-->
<!--        padding: 5px 15px;-->
<!--        font-size: 20px;-->
<!--        cursor: pointer;-->

<!--        &:not(:last-of-type) {-->
<!--          margin-bottom: 15px;-->
<!--        }-->

<!--        &:active {-->
<!--          background-color: #bfbfbf;-->
<!--        }-->

<!--        svg {-->
<!--          margin-right: 15px;-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--</style>-->
